import Label from "./Label";

function Badges({ product }) {
	return (
		<div className="badge-container">
			{product.discounted == 1 && (
				<div className="label-promo">
					<Label number={110} />
				</div>
			)}
			{product.vegan == 1 && (
				<div className="label-vegan">
					<Label number={9} />
				</div>
			)}
			{product.gluten_free == 1 && (
				<div className="label-gluten">
					<Label number={10} />
				</div>
			)}
			{product.disabled == 1 && (
				<div className="label-available">
					<Label number={11} />
				</div>
			)}
		</div>
	);
}

export default Badges;
